import React from 'react';

import { fetchCalendarMembers, fetchCalendarPmas } from '../../../../../api/calendarApi';
import { fetchAdminHacs, fetchAdminPmas } from '../../../../../api/adminHacTableApi';
import { getDecodedToken } from '../../../../../utils/auth';
import { isAdminRole, isPmaRole } from '../../../../../utils/role-utils';
import { dedupeById } from '../../../../../utils/tableUtils';

const getRows = (result) =>
  result.status === 'fulfilled' && Array.isArray(result.value?.data)
    ? result.value.data
    : [];

const getCurrentPmaOption = (user) => {
  if (!user?.id || !isPmaRole(user.role)) return null;

  let loggedUser = null;
  try {
    loggedUser = JSON.parse(sessionStorage.getItem('loggedUser') || 'null');
  } catch (_error) {
    loggedUser = null;
  }

  return {
    ...(loggedUser || {}),
    id: user.id,
    name: loggedUser?.name ?? user.name ?? '',
    last_name: loggedUser?.last_name ?? user.last_name ?? '',
  };
};

export function useCalendarFilterOptions(token) {
  const [pmas, setPmas] = React.useState([]);
  const [members, setMembers] = React.useState([]);

  React.useEffect(() => {
    if (!token) return undefined;

    let isActive = true;

    const loadOptions = async () => {
      const user = getDecodedToken(token);
      const pmaRequest = isAdminRole(user?.role)
        ? fetchAdminPmas(token)
        : fetchCalendarPmas(token);
      const memberRequest = isAdminRole(user?.role)
        ? fetchAdminHacs(token)
        : user?.id
          ? fetchCalendarMembers(token, user.id)
          : Promise.resolve({ data: [] });
      const [pmaResult, memberResult] = await Promise.allSettled([
        pmaRequest,
        memberRequest,
      ]);

      if (!isActive) return;
      const currentPma = getCurrentPmaOption(user);
      setPmas(dedupeById([currentPma, ...getRows(pmaResult)].filter(Boolean)));
      setMembers(dedupeById(getRows(memberResult)));
    };

    loadOptions();
    return () => { isActive = false; };
  }, [token]);

  return { pmas, members };
}
